import(/* webpackMode: "eager" */ "/src/app/about/page.tsx");
